<template>
    <div class="antpanels_wrap">
        <div class="base">
            <div class="overlay"></div>
            <div class="underlay"></div>
            <div class="ant ant1"></div>
            <div class="ant ant2"></div>
            <div class="ant ant3"></div>
            <div class="ant ant4"></div>
        </div>
        <div class="caption">
            <slot>Retrieving Tasks...</slot>
        </div>
    </div>
</template>